// File: frontend/src/components/entries/SpoilerBlock.tsx

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { renderBasicMarkup } from "../../utils/inlineMarkup";
import "./SpoilerBlock.css";

interface SpoilerBlockProps {
  /** Raw spoiler text extracted from the (spoiler: ...) token */
  text: string;
}

/**
 * Collapsed spoiler block for (spoiler: ...) tokens.
 * The content stays hidden behind a warning-colored toggle bar until the
 * reader clicks it; clicking again collapses the content back. Shared by
 * EntryRow, EntryPostForm/DraftsPage previews, and the admin preview.
 */
export const SpoilerBlock: React.FC<SpoilerBlockProps> = ({ text }) => {
  const { t } = useTranslation();
  const [revealed, setRevealed] = useState(false);

  return (
    <span className="spoiler-block">
      <button
        type="button"
        className={`spoiler-toggle${revealed ? " spoiler-toggle--open" : ""}`}
        onClick={() => setRevealed((prev) => !prev)}
      >
        {revealed ? t("spoiler_hide") : t("spoiler_show")}
      </button>
      {revealed && <span className="spoiler-content">{renderBasicMarkup(text)}</span>}
    </span>
  );
};